@if (step === 'contact-sales') {
  <app-availability-contact-sales (selected)="onComplete()"></app-availability-contact-sales>
}
@if (initialized) {
  <div>
    @if (step === 'select') {
      <app-select-availability
        [selectedAilability]="model.availability"
        [availabilityLevels]="model.availabilityLevels"
        (premiumSelected)="onPremiumSelected()"
        (standardSelected)="onStandardSelected()"
        (back)="onAvailabilityBack()"
      ></app-select-availability>
    }
    @if (step === 'downgrade') {
      <app-warning-confirm-box
        [hideCancelBtn]="true"
        [confirmHeadline]="'availability_downgrade_premium_confirm_headline' | i18next"
        [confirmDetailsHeadline]="'availability_downgrade_premium_confirm_headline' | i18next"
        [confirmDetailsText]="'availability_downgrade_premium_confirm_text' | i18next"
        [confirmBtn]="'availability_downgrade_premium_confirm_btn' | i18next"
        [footerCancelBtnText]="'availability_downgrade_premium_confirm_btn_cancel' | i18next"
        (back)="onDowngradeBack()"
        (confirm)="onDowngradeSelected()"
      ></app-warning-confirm-box>
    }
    @if (step === 'address') {
      <app-invoice-address
        (next)="onInvoiceNext($event)"
        (backEvent)="onInvoiceAddressBack()"
      [historyBack]="false"></app-invoice-address>
    }
    @if (step === 'payment') {
      <app-payment-method
        (next)="onPaymentMethod($event)"
        (backEvent)="onPaymentMethodBack()"
        [onlyEmit]="true"
        [historyBack]="false"
        [paymentMethod]="model?.saleOrder?.payment_method ?? model?.subscription?.payment_method" >
      </app-payment-method>
    }
    @if (step === 'checkout') {
      <app-checkout-one-summary
        [subscription]="model.subscription"
        (back)="onSummaryBack()"
        [historyBack]="false"
        (buy)="onBuy()" >
      </app-checkout-one-summary>
    }
    @if (step === 'complete') {
      <app-endcustomer-upgrade-order-complete (next)="onComplete()"></app-endcustomer-upgrade-order-complete>
    }
  </div>
}